import { Observable, UnaryFunction, pipe } from 'rxjs';
import { FeatureFlagDataModel } from '../models/feature-flag.model';
import { filter, map } from 'rxjs/operators';

export const getFeatureFlagEnabledByName$ = (
  name: string
): UnaryFunction<Observable<FeatureFlagDataModel[]>, Observable<boolean>> =>
  pipe(
    filter((featureFlags) => !!featureFlags),
    map<FeatureFlagDataModel[], boolean>((featureFlags) => getFeatureFlagEnabledByName(featureFlags, name))
  );

export const getFeatureFlagEnabledByName = (featureFlags: FeatureFlagDataModel[] = [], name: string) => {
  const flag = featureFlags.find((flag) => flag?.featureFlagData?.name === name);
  return Boolean(flag?.featureFlagData?.enabled);
};
